import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { ServiceAdvisorShedule } from "./api-interfaces/api-interface-service-advisor-schedule";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIServiceAdvisorSchedule{
    ApiURL: string = "";
    constructor(private http: HttpClient, public helperService: HelperService) {
        this.ApiURL = environment.ServiceAdvisorSchedule + 'ServiceAdvisorSchedule/';
    }

    public getByAdvisor(advisorId: number):Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get(this.ApiURL + 'byAdvisor/'+encodeURIComponent(advisorId), requestOptions);
    }

    public get(id: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        if (id !== null && id !== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(id), requestOptions);
        } else {
            return this.http.get(this.ApiURL, requestOptions);
        }
    }

    public getWebviewHoursAdvisorDropDownLists(date,hour,serviceId,workshopId,brandid ): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };
        const url =`${this.ApiURL}byAdvisorAvailable/${date}/${hour}/${workshopId}/${serviceId}/${brandid}`; ;

        return this.http.get(url, requestOptions);
    }

    public post(dataInt:ServiceAdvisorShedule): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.post<any>(this.ApiURL, dataInt, requestOptions)
    }

    public put(dataInt:ServiceAdvisorShedule): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.put<any>(this.ApiURL, dataInt, requestOptions)
    }

    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL, requestOptions)
    }
}
